import { Box, Stack } from "@mui/material";
import ProposalActionItemCard from "./ProposalActionItemCard";
import { ProposalActionItem } from "../../../../types/proposal.types";
import { BookingData } from "../../../../../types/view-booking";
import { CalendarIcon } from "../../../../../../../components/icons/CalendarIcon";

interface ProposalSidebarProps {
  actionItems: ProposalActionItem[];
  bookingData?: BookingData | null;
}

export default function ProposalSidebar({
  actionItems,
  bookingData,
}: ProposalSidebarProps) {
  const deceased = bookingData?.beloved;
  const dateOfDeath = bookingData?.beloved?.details?.dateOfDeath;

  const getDaysUntilAnniversary = (dod: string): number | null => {
    if (!dod || dod === "N/A") return null;

    const [day, month, year] = dod.split("-");
    const death = new Date(Number(year), Number(month) - 1, Number(day));
    if (isNaN(death.getTime())) return null;

    const today = new Date();
    const next = new Date(
      today.getFullYear(),
      death.getMonth(),
      death.getDate(),
    );
    if (next <= today) next.setFullYear(today.getFullYear() + 1);
    return Math.ceil(
      (next.getTime() - today.getTime()) / (1000 * 60 * 60 * 24),
    );
  };

  const daysUntil = dateOfDeath ? getDaysUntilAnniversary(dateOfDeath) : null;
  const anniversaryTitle =
    daysUntil !== null
      ? `${daysUntil} days until ${deceased?.name}'s anniversary`
      : "No anniversary data available";

  const dynamicActionItems: ProposalActionItem[] = [
    {
      icon: <CalendarIcon sx={{ color: "#007AFF" }} />,
      title: anniversaryTitle,
      subtitle: "Send message to family",
      onClick: () =>{}
    },
    ...actionItems.slice(1),
  ];

  return (
    <Box sx={{ width: 280, flexShrink: 0 }}>
      <Stack spacing={1}>
        {dynamicActionItems.map((item, index) => (
          <ProposalActionItemCard key={index} item={item} />
        ))}
      </Stack>
    </Box>
  );
}
